/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 使用refreshtoken刷新获取新的token
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  oauthRefreshDto: oauth2.OauthRefreshDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.Token;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/token-refresh`,
    data: oauthRefreshDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
